import Layout from 'components/layout';
import { Card } from 'antd';

import styles from '../style.module.scss';

const StripeFailure = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <Card title={'Stripe onboarding'}>
          L'onboarding di Stripe non è riuscito
        </Card>
      </div>
    </Layout>
  );
};

export default StripeFailure;
